import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";

const POSTS = [
  { badge: "Fragrance Guides", title: "Choosing your first Scentodore", body: "How to translate the fragrances you already love into a Scentodore that suits your day-to-day. A pragmatic starter guide." },
  { badge: "Scent Education", title: "Extrait, EDP, EDT — what actually differs", body: "The chemistry, the concentration, and how the label affects wear on skin. A quick, no-fluff primer." },
  { badge: "Fragrance Notes", title: "Reading a note pyramid", body: "Top, heart, and base explained — and how to guess whether you’ll like a fragrance by scanning its pyramid." },
  { badge: "How to Choose", title: "A fragrance for every impression", body: "Matching scent to occasion — office, evening, weekend, first date. Framework, not rules." },
  { badge: "Layering", title: "Two scents that make a third", body: "An introduction to layering roll-ons and extraits without either voice cancelling the other out." },
  { badge: "Fragrance Care", title: "Making a bottle last three years", body: "Storage, application, and a few small habits that keep an extrait performing well past its second birthday." },
  { badge: "Gift Guides", title: "Fragrances by personality", body: "A gifting map — quiet elegance, warm and inviting, memorable and unusual — with Scentodore matches for each." },
  { badge: "Behind the Brand", title: "Why we chose Canada", body: "An honest note from the founders on why Scentodore is bottled in Canada, and how that shapes what ends up in your bottle." },
];

const SUGGEST = [{
  heading: "Suggest a topic",
  body: "The best essays start as reader questions. If there’s something you wish someone would explain about fragrance — tell us. Reader-suggested topics are our favourite prompts.",
}];

export default function JournalPage() {
  return (
    <PageShell
      slug="journal"
      testid="journal"
      eyebrow="The Journal"
      title="Reading room for the fragrance-curious."
      intro="Long-form essays on scent, craft, and the small rituals that make fragrance part of daily life. Written by the Scentodore team and occasional guests."
    >
      <div className="mb-8 flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#C5A059]">
        <BookOpen className="h-3.5 w-3.5" />
        <span>New essays published monthly</span>
      </div>

      <div className="mb-14">
        <EditableFeatureGrid slug="journal" sectionKey="posts" fallback={POSTS} />
      </div>

      <EditableSection slug="journal" sectionKey="suggest" fallback={SUGGEST} />
      <div className="-mt-8">
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 text-[#C5A059] hover:underline text-sm"
        >
          Suggest a topic <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </PageShell>
  );
}
